// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__18DW2","alert":"SettungsInbox_alert__1GQV-"};